import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";
import { X, UserPlus } from "lucide-react";

export const MAX_VEHICLE_DRIVERS = 4;
export const vehicleDriverIds = (v) => (v?.assigned_driver_ids?.length ? v.assigned_driver_ids : (v?.current_driver_id ? [v.current_driver_id] : []));
export const driverName = (d) => d ? `${d.first_name || ""} ${d.last_name || ""}`.trim() : "Autista";

/** Selettore multiplo "Autisti assegnati" (0-4): chip con rimozione + menu per aggiungere. */
export function MultiDriverPicker({ value, onChange, drivers, testid = "assigned-drivers" }) {
  const byId = Object.fromEntries(drivers.map(d => [d.id, d]));
  const shown = drivers.length ? value.filter(id => byId[id]) : value;
  const available = drivers.filter(d => d.active !== false && !value.includes(d.id));
  const full = shown.length >= MAX_VEHICLE_DRIVERS;
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex flex-wrap gap-1.5 min-h-[32px]">
        {shown.length === 0 && <span className="text-xs italic text-slate-500">Nessun autista assegnato</span>}
        {shown.map((id, i) => (
          <span key={id} className="inline-flex items-center gap-1 rounded-full border border-amber-500/50 bg-amber-500/10 text-amber-100 text-xs pl-2.5 pr-1 py-1" data-testid={`${testid}-chip-${id}`}>
            {driverName(byId[id])}{i === 0 && <span className="text-[9px] uppercase text-amber-400/80 ml-0.5">principale</span>}
            <button type="button" onClick={() => onChange(shown.filter(x => x !== id))} className="rounded-full p-0.5 hover:bg-amber-500/20" aria-label="Rimuovi" data-testid={`${testid}-remove-${id}`}><X size={12} /></button>
          </span>
        ))}
      </div>
      <Select value="" onValueChange={id => id && !full && onChange([...shown, id])} disabled={full}>
        <SelectTrigger className="bg-slate-900 border-slate-800 [&>span]:flex [&>span]:items-center" data-testid={`${testid}-add`}>
          <span className="flex flex-row items-center gap-2 whitespace-nowrap text-slate-400"><UserPlus size={14} className="shrink-0" />{full ? `Massimo ${MAX_VEHICLE_DRIVERS} autisti raggiunto` : `Aggiungi autista (${shown.length}/${MAX_VEHICLE_DRIVERS})`}</span>
        </SelectTrigger>
        <SelectContent className="bg-slate-950 border-slate-800">
          {available.map(d => <SelectItem key={d.id} value={d.id}>{driverName(d)}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
